export default __webpack_public_path__ + "static/media/triangle-pediatrie.c848a362.png";